import { useMutation, useQuery } from "@tanstack/react-query";
import {
  addcomment,
  blogdetails,
  blogdislike,
  bloglike,
  blogList,
  blogsave,
  commentlists,
  deletecomment,
  successstorydetailed,
} from "api/blog";
import AlertNotification from "components/CustomWidgets/alertNotification";

export const useBlogList = () => {
  return useQuery({
    queryKey: ["blogList"],
    queryFn: blogList,
  });
};

export const useBlogDetails = (blogId, options = {}) => {
  return useQuery({
    queryKey: ["blogDetails", blogId],
    queryFn: () => blogdetails(blogId),
    enabled: !!blogId,
    ...options,
  });
};

export const useBlogLike = (options = {}) => {
  return useMutation({
    mutationFn: bloglike,
    onSuccess: (data, variables, context) => {
      AlertNotification("success", data.message || "Blog liked successfully!");
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const useBlogDisLike = (options = {}) => {
  return useMutation({
    mutationFn: blogdislike,
    onSuccess: (data, variables, context) => {
      AlertNotification("success", data.message || "Disliked added!");
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const useBlogSave = (options = {}) => {
  return useMutation({
    mutationFn: blogsave,
    onSuccess: (data, variables, context) => {
      AlertNotification("success", data.message || "Blogs Saved successfully!");
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const useAddComment = (options = {}) => {
  return useMutation({
    mutationFn: addcomment,
    onSuccess: (data, variables, context) => {
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const useCommentLists = ({ blog_id, sort_order }, options = {}) => {
  return useQuery({
    queryKey: ["comment-list", { blog_id, sort_order }],
    queryFn: commentlists,
    ...options,
  });
};

export const usesuccessstorydetailed = ({ id }, options = {}) => {
  return useQuery({
    queryKey: ["successstory-detailed", { id }],
    queryFn: successstorydetailed,
    ...options,
  });
};

export const useDeleteComment = (options = {}) => {
  return useMutation({
    mutationFn: deletecomment,
    onSuccess: (data, variables, context) => {
      options.onSuccess?.(data, variables, context);
    },
  });
};
